import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const RefundPolicyPage: React.FC = () => {
  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Refund Policy" pagesub="Refund Policy" />
            <section className="legal-content py-100">
              <div className="container">
                <div className="legal-content-wrap" style={{ maxWidth: "900px", margin: "0 auto" }}>
                  
                  <p style={{ fontSize: "16px", marginBottom: "30px", color: "rgba(255,255,255,0.7)" }}>
                    <strong>Last updated:</strong> July 12, 2026
                  </p>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>General Refund Overview</h2>
                  
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    At <strong>Aquar Labs</strong>, we specialize in delivering bespoke digital services, custom software, AI agents, cloud solutions, and tailored enterprise tools. Because our services are highly customized to meet the unique requirements of each client, we do not support automated transactions or standardized refund structures.
                  </p>

                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    All acquisitions and purchasing processes for our digital services are facilitated exclusively through official email communication and mutual consultation. 
                  </p>

                  <div style={{ 
                    background: "rgba(252, 144, 56, 0.1)", 
                    border: "1px solid rgba(252, 144, 56, 0.3)", 
                    borderRadius: "10px", 
                    padding: "20px", 
                    marginBottom: "30px" 
                  }}>
                    <p style={{ lineHeight: "1.8", margin: 0, fontWeight: "600" }}>
                      PLEASE NOTE: Refunds are only possible if they are explicitly outlined and agreed upon in a signed Memorandum of Understanding (MOU), legal Service Agreement, or client-approved quotation.
                    </p>
                  </div>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>Key Policies</h2>
                  
                  <h3 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "15px" }}>1. Official Purchase Process</h3>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    All requests, requirements definitions, quotations, proposals, and orders for our services must be conducted through our official email communication channels (ending in <code>@aquarlabs.com</code>). Transactions or commitments made outside of our official email domains or unauthorized third-party platforms are not recognized or eligible for refund consideration.
                  </p>

                  <h3 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "15px" }}>2. Eligibility for Refunds</h3>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    Refunds are not automatically granted. A refund is only eligible and processed under the specific terms detailed inside:
                  </p>
                  <ul style={{ lineHeight: "2", marginBottom: "30px", paddingLeft: "25px" }}>
                    <li>A legally signed Memorandum of Understanding (MOU) between the client and Aquar Labs.</li>
                    <li>An officially approved and signed Project Quotation or Service Level Agreement (SLA).</li>
                    <li>A legally binding Master Services Agreement (MSA) containing specific refund, cancellation, or milestone termination clauses.</li>
                  </ul>

                  <h3 style={{ fontSize: "22px", marginTop: "30px", marginBottom: "15px" }}>3. Variable Refund Structure</h3>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    As each project has a different scope, resource allocation, and timeline, refund percentages and criteria are variable and customized for each individual client or customer. 
                  </p>
                  <p style={{ lineHeight: "1.8", marginBottom: "20px" }}>
                    Specific refund details, including milestone-based payouts, non-refundable setup fees, work-in-progress compensations, and contract termination policies, are strictly governed by the approved quotation or legal agreement associated with the project.
                  </p>

                  <h2 style={{ fontSize: "28px", marginTop: "40px", marginBottom: "20px", color: "#fc9038" }}>Contact Us</h2>
                  <p style={{ lineHeight: "1.8", marginBottom: "15px" }}>
                    If you have questions regarding an ongoing quotation, an MOU, or our refund guidelines, please contact us via our official channels:
                  </p>
                  
                  <div style={{ 
                    background: "rgba(255, 255, 255, 0.05)", 
                    borderRadius: "10px", 
                    padding: "25px", 
                    marginTop: "20px" 
                  }}>
                    <p style={{ lineHeight: "2", margin: 0 }}>
                      <strong style={{ color: "#fc9038" }}>Aquar Labs LLP</strong><br />
                      Appughar, Sector 10, MVP Colony<br />
                      Vizag, Andhra Pradesh - 530017<br /><br />
                      <strong>Email:</strong> <a href="mailto:info@aquarlabs.com" style={{ color: "#fc9038" }}>info@aquarlabs.com</a><br />
                      <strong>Website:</strong> <a href="https://www.aquarlabs.com" style={{ color: "#fc9038" }}>www.aquarlabs.com</a><br />
                      <strong>Phone:</strong> <a href="tel:+918367036704" style={{ color: "#fc9038" }}>+91 8 3670 3670 4</a>
                    </p>
                  </div>

                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default RefundPolicyPage;
